import React from "react";

import Button from "../../../Components/Button";
import CommonModal from "../../../Components/Modal";
import "./style.scss";

interface ResetPasswordModalProps {
  isOpen: boolean;
  toggle: () => void;
  userName: string;
  onSubmit: () => void;
  loading?: boolean;
}

const ResetPasswordModal: React.FC<ResetPasswordModalProps> = ({
  isOpen,
  toggle,
  userName,
  onSubmit,
  loading = false,
}) => {
  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title="Send Password Reset Link"
      size="md"
    >
      <div className="reset-password-modal">
        <p className="reset-description">
          A password reset email will be sent to <strong>{userName}</strong>.
          Their existing password will continue to work until they complete the
          password reset process.
        </p>

        <div className="modal-actions">
          <Button variant="secondary" onClick={toggle} disabled={loading}>
            Cancel
          </Button>
          <Button
            loading={loading}
            variant="danger"
            onClick={onSubmit}
            disabled={loading}
          >
            Send Reset Email
          </Button>
        </div>
      </div>
    </CommonModal>
  );
};

export default ResetPasswordModal;
